import { ProductEvent } from "@classdojo/log-client/lib/client/client";
import entries from "lodash/entries";
import map from "lodash/map";

function executeCommand(cmd: string, queryParams: Record<string, string | number | boolean> = {}) {
  let iFrame: HTMLElement | null = document.createElement("IFRAME");
  queryParams._cacheDefeat = new Date().getTime();
  const queryString = map(entries(queryParams), ([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
  iFrame.setAttribute("src", `${cmd}?${queryString}`);
  document.body.appendChild(iFrame);
  iFrame.parentNode?.removeChild(iFrame);
  iFrame = null;
}

export function init() {
  executeCommand("classdojo://command/init");
}

export const showNativeNav = (shouldShow: boolean) => {
  executeCommand("classdojo://command/showNav", { shouldShow });
};

export const closeWebview = () => {
  executeCommand("classdojo://command/close");
};

export function openSalesPage() {
  executeCommand("classdojo://command/openSalesPage");
}

export function openPointsSheet() {
  executeCommand("classdojo://command/openPointsSheet");
}

export const logEvent = (event: ProductEvent) => {
  executeCommand("classdojo://command/logEvent", { name: event.eventName, metadata: JSON.stringify(event.metadata) });
};
